import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const Key: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="m13.19 4.55.16-.14-4.21 1.37-1 3.8a3.78 3.78 0 0 0 .61 1.24L7.5 12.09 7 14l2 .15v-.74l1.85-1.85a1 1 0 0 0 0-1.41l-.3-.3a1.88 1.88 0 0 1 0-2.65ZM8 16a1 1 0 0 0 1-1v-.85L7 14H6a1 1 0 0 0-1 1v1H4a1 1 0 0 0-.71.29l-.41.42-.12.13A3 3 0 0 0 2 18.83v1.35A2 2 0 0 0 4 22h1.43a3 3 0 0 0 1.86-.87l5.88-5.88a3.88 3.88 0 0 0 5-.38l-7-.53-5.29 5.37a1 1 0 0 1-.6.28H4v-1.16a1 1 0 0 1 .22-.63l.09-.1.1-.1H6a1 1 0 0 0 1-1v-1Zm5.85-2.85a1 1 0 0 0-1.41 0l-1.18 1.18 7 .53 2.64-2.64V6.74l-3.6-3.6-2.7.86a1.89 1.89 0 0 1 1.25.55l3.6 3.6a1.88 1.88 0 0 1 0 2.65l-2.64 2.64a1.88 1.88 0 0 1-2.65 0l-.3-.3ZM15 8a1 1 0 0 0 0 2 1 1 0 0 0 0-2Zm6.7 0a3.81 3.81 0 0 0-.84-1.26v5.48A3.85 3.85 0 0 0 21.7 8ZM8.3 7a3.82 3.82 0 0 0-.15 2.54l1-3.8A3.81 3.81 0 0 0 8.3 7Zm5.5-2.9a2 2 0 0 1 .8-.1l2.66-.86a3.86 3.86 0 0 0-5.48 0L9.14 5.78l4.21-1.37a2.07 2.07 0 0 1 .45-.27Z" />
  </Icon>
);

export default Key;
